import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./css/Sidebar.css";

function Sidebar() {
  const [openMenus, setOpenMenus] = useState({
    events: false,
    religious: false,
    general: false,
  });

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  return (
    <aside className="sidebar">
      <ul className="menu">
        <li>
          <NavLink to="/" end className={({ isActive }) => (isActive ? "active" : "")}>
            Home
          </NavLink>
        </li>

        <li>
          <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : "")}>
            Contact
          </NavLink>
        </li>

        {/* EVENTS */}
        <li>
          <div className="menu-title" onClick={() => toggleMenu("events")}>
            Events <span className="arrow">{openMenus.events ? "▾" : "▸"}</span>
          </div>
          {openMenus.events && (
            <ul className="submenu">
              <li>
                <NavLink to="/events/past" className={({ isActive }) => (isActive ? "active" : "")}>
                  Past Events
                </NavLink>
              </li>
              <li>
                <NavLink to="/events/upcoming" className={({ isActive }) => (isActive ? "active" : "")}>
                  Upcoming Events
                </NavLink>
              </li>
            </ul>
          )}
        </li>

        {/* RELIGIOUS INFO */} 
        <li>
          <div className="menu-title" onClick={() => toggleMenu("religious")}>
            Religious Information{" "}
            <span className="arrow">{openMenus.religious ? "▾" : "▸"}</span>
          </div>
          {openMenus.religious && (
            <ul className="submenu">
              <li><NavLink to="/religious/mosques" className={({ isActive }) => (isActive ? "active" : "")}>Mosques</NavLink></li>
              <li><NavLink to="/religious/halalmeat" className={({ isActive }) => (isActive ? "active" : "")}>Halal Meat</NavLink></li>
              <li><NavLink to="/religious/circumcision" className={({ isActive }) => (isActive ? "active" : "")}>Circumcision</NavLink></li>
              <li><NavLink to="/religious/umrah" className={({ isActive }) => (isActive ? "active" : "")}>Umrah</NavLink></li>
              <li><NavLink to="/religious/salahtimings" className={({ isActive }) => (isActive ? "active" : "")}>Salah Timings</NavLink></li>
              <li><NavLink to="/religious/mosquefee" className={({ isActive }) => (isActive ? "active" : "")}>Mosque Fee</NavLink></li>
            </ul>
          )}
        </li>

        {/* GENERAL INFO */}
        <li>
          <div className="menu-title" onClick={() => toggleMenu("general")}>
            General Information{" "}
            <span className="arrow">{openMenus.general ? "▾" : "▸"}</span>
          </div>
          {openMenus.general && (
            <ul className="submenu">
              <li><NavLink to="/general/englishschools" className={({ isActive }) => (isActive ? "active" : "")}>English Schools</NavLink></li>
              <li><NavLink to="/general/regularevents" className={({ isActive }) => (isActive ? "active" : "")}>Regular Events</NavLink></li>
              <li><NavLink to="/general/firstday" className={({ isActive }) => (isActive ? "active" : "")}>First Day</NavLink></li>
              <li><NavLink to="/general/nrochecklist" className={({ isActive }) => (isActive ? "active" : "")}>NRO Checklist</NavLink></li>
            </ul>
          )}
        </li>

        <li>
          <NavLink to="/board" className={({ isActive }) => (isActive ? "active" : "")}>
            Board
          </NavLink>
        </li>

        <li>
          <NavLink to="/photogallery" className={({ isActive }) => (isActive ? "active" : "")}>
            Photo Gallery
          </NavLink>
        </li>

        <li>
          <NavLink to="/blogs" className={({ isActive }) => (isActive ? "active" : "")}>
            Blogs
          </NavLink>
        </li>
      </ul>
    </aside>
  );
}

export default Sidebar;
